function Error() {

  return <h1>(Error occured)</h1>
  }

  export default Error;